import type React from 'react';

import { InfoSection } from '../components/InfoSection';
import { RecipientSection } from '../components/RecipientSection';
import { TitleSection } from '../components/TitleSection';

export const Layout: React.FC = () => {
	return (
		<>
			<TitleSection />
			<InfoSection />
			<RecipientSection />
		</>
	);
};
